// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1zi5z","balanceDisclaimer":"posDashboard_balanceDisclaimer__1t4ww"};